import React from "react";
import currencies from "@/data/currency.json";
const CurrencySelector = ({ currency, setCurrency }) => {
  return (
    <div className="flex items-center justify-between xsm:w-auto w-full gap-3 sm:gap-4 rounded-lg bg-[#E7EDF4] py-0.5 pl-2 sm:pl-4 pr-0.5">
      <span className="text-[#757C7F] text-sm font-medium">
        Para Birimi
      </span>
      <div className="flex items-center gap-3 px-3 py-3 bg-white rounded-md md:gap-6 lg:py-4 lg:px-5">
        {currencies.map((item) => (
          <button
            key={item.name}
            type="button"
            className={`${
              currency === item.name
                ? "text-themeSecondColor"
                : "text-[#757C7F] text-opacity-40"
            }  text-sm font-bold leading-normal`}
            onClick={() => setCurrency(item.name)}
          >
            {item.text}
          </button>
        ))}
      </div>
    </div>
  );
};

export default CurrencySelector;
